module.exports = __webpack_public_path__ + "img/Dot Holder Six Correct Numbers.9c39ea81.png";